"use client";

import { Link } from "@/i18n/navigation";
import { getCityGenreFilterHref, getGenreTagHref } from "@finda/shared/genres";
import { useFeedGenreFilter, useGenreTagLinkMode } from "./feed-genre-filter-context";

/** Raw artist tags can open an exact directory filter or a genre calendar. */
export function EventGenreChip({ genre, citySlug, pill = false }: {
  genre: string; citySlug?: string | null; pill?: boolean;
}) {
  const feedFilter = useFeedGenreFilter();
  const mode = useGenreTagLinkMode();
  const isActive = feedFilter?.selectedGenres.some((value) => value.toLowerCase() === genre.toLowerCase()) ?? false;
  const className = `relative z-10 pointer-events-auto font-mono text-[10px] text-acid transition-colors ${pill ? "rounded-full border border-acid/30 px-2 py-0.5" : ""} ${isActive ? "underline decoration-acid/70 underline-offset-2" : ""}`;
  const label = genre.toUpperCase();
  if (citySlug) {
    const href = mode === "directory" ? getCityGenreFilterHref(citySlug, genre) : getGenreTagHref(citySlug, genre);
    // Only the inventory-gated city directory/footer promote calendars to
    // crawlers. Tags can also reach thin calendars and arbitrary raw filters.
    return <Link href={href} prefetch={false} rel="nofollow"
      onClick={(event) => {
        event.stopPropagation();
        if (mode === "directory" || !feedFilter || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        feedFilter.selectGenre(genre);
      }} className={`${className} cursor-pointer hover:text-white`}>{label}</Link>;
  }
  if (feedFilter) {
    return <button type="button" onClick={(event) => { event.preventDefault(); event.stopPropagation(); feedFilter.selectGenre(genre); }} className={`${className} cursor-pointer hover:text-white`}>{label}</button>;
  }
  return <span className={className}>{label}</span>;
}
